const OperationType = {
  Buy: 'Buy',
  ['Received from outer']: 'ReceivedFromOuter',
  ['Sent out']: 'SentOut',
  Sell: 'Sell',
};

export default OperationType;
